/**
 * Names of the different packages/solutions being provisioned for CDS
 */ export var CdsPackageName = /*#__PURE__*/ function(CdsPackageName) {
    /** Package required for premium plans */ CdsPackageName["Project"] = "ModProj";
    /** Package required for portfolios */ CdsPackageName["Roadmap"] = "Roadmap";
    return CdsPackageName;
}({});
/** List of CDS package names */ export const CdsPackageNamesList = [
    "ModProj",
    "Roadmap"
];
